import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { IStyledVariantProps } from '../../../../model';
import { VariantCommon } from '../../variantsStyled';

type VariantProps = IStyledVariantProps & {
  newDesign: boolean;
  isDualPriceForCroatia: boolean;
};
export const Variant = styled(VariantCommon)<VariantProps>`
  ${({ newDesign, isSelected, isOnStock, isDualPriceForCroatia }) =>
    newDesign
      ? css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: ${
            isOnStock && isDualPriceForCroatia ? 'center' : 'space-between'
          };
          margin: 0 0 0.25rem;
          border 2px solid ${
            isSelected
              ? theme.palette.basic
              : isOnStock
              ? theme.palette.neutral
              : theme.palette.neutralLight
          };
          background-color: ${theme.palette.basicInverse};
          height: 3.5rem;
          width: 6.5rem;
          padding: 0.625rem 0.5rem;
          @media (min-width: ${breakpoints.lg}) {
            width: auto;
            margin: 0;
          }
        `
      : css`
          min-height: 3.625rem;
          border 1px solid ${(props: IStyledVariantProps) =>
            props.isSelected
              ? props.theme.palette.neutral
              : props.theme.palette.neutralLighter};
          background-color: ${(props) =>
            props.isSelected
              ? props.theme.palette.basicInverse
              : props.theme.palette.neutralLighter};

          &:hover {
            background-color: ${(props) =>
              !props.isSelected && props.theme.palette.neutralLight};
          }

          padding: 0.375rem 1.875rem 0.375rem 0.625rem;
          @media (min-width: ${breakpoints.sm}) {
            min-width: 6.8rem;
          }
        `}
`;

interface IPriceLabelWrapperProps {
  isOnStock: boolean;
  isSelected: boolean;
  newDesign: boolean;
}

export const PriceLabelWrapper = styled.div<IPriceLabelWrapperProps>`
  ${({ newDesign, isOnStock, isSelected }) =>
    newDesign
      ? css`
          ${theme.typography.labelSmall400}
          color:${theme.palette.neutralDarker}
        `
      : css`
          color: ${isOnStock ? theme.palette.basic : theme.palette.neutral};
          font-weight: ${isSelected ? 'bold' : 'normal'};
          font-size: 0.9rem;
        `}
`;

export const Unavailable = styled.p`
  ${theme.typography.labelSmall400}
  color:${theme.palette.neutralDark}
`;
